import { useReactiveVar } from '@apollo/client';
import { visibilityVar } from '@vars';
import { useEffect, useRef } from 'react';

interface UseBrowserVisiblity {
  onVisible?: () => void;
  onInVisible?: () => void;
}

const useBrowserVisiblity = (callback: UseBrowserVisiblity) => {
  const callbackRef = useRef(callback);
  const visibility = useReactiveVar(visibilityVar);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    visibility && callbackRef.current.onVisible?.();
  }, [visibility]);

  useEffect(() => {
    if (visibility) {
      callbackRef.current.onVisible?.();
    } else {
      callbackRef.current.onInVisible?.();
    }
  }, [visibility]);
};

export default useBrowserVisiblity;
